module.exports = __webpack_public_path__ + "img/iletisim-logo.6e8068fe.svg";